import { makeStyles } from "@material-ui/core";
import { CardapioDadosProps } from "../../cardapio-header-props";

interface StyleProps {
    dados: CardapioDadosProps | undefined;
    idValido: boolean;
}

export const useStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column-reverse',
        },
    },
    centralizar: {
        justifyContent: ({ idValido }: StyleProps) =>
            idValido
                ? 'flex-end'
                : 'center',
        width: '100%',
    },
    removeMargin: {
        marginTop: 0
    },
    horarioContainer: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
    },
    btnFechado: {
        backgroundColor:
            theme.palette.type === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
    },
    informacoes: { width: 'unset' },
    informacoesCarregando: { width: '85%' },
    textoInfo: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: 500
    },
    pointer: {
        cursor: 'pointer',
    },
    iconInfo: {
        marginRight: '.5rem',
        color: theme.palette.primary.main
    },
    popper: {
        zIndex: 1,
    },
    item: {
        padding: 0,
    },
    destaque: {
        fontWeight: 'bold',
    },
    listItem: { display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' },
    listPrimary: { marginRight: '1rem', flex: 1 },
    listSecondary: { flex: 1 },
}));